import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PayarcPageHeaderComponent } from './page-header/payarc-page-header.component';
import { PayarcFilterBarComponent } from './filter-bar/payarc-filter-bar.component';
import { PayarcDetailCardComponent } from './detail-card/payarc-detail-card.component';
import { PayarcStatTileComponent } from './stat-tile/payarc-stat-tile.component';
import { PayarcStatusBadgeComponent } from './status-badge/payarc-status-badge.component';
import { PayarcEmptyStateComponent } from './empty-state/payarc-empty-state.component';
import { PayarcSectionCardComponent } from './section-card/payarc-section-card.component';
import { PayarcDialogShellComponent } from './dialog/payarc-dialog-shell.component';
import { PayarcFormFieldComponent } from './form-field/payarc-form-field.component';
import { PayarcCardComponent } from './card/payarc-card.component';
import { PayarcSectionTitleComponent } from './section-title/payarc-section-title.component';
import { PayarcSegmentedComponent } from './segmented/payarc-segmented.component';
import { PayarcInlineAlertComponent } from './inline-alert/payarc-inline-alert.component';
import { PayarcDonutComponent } from './donut/payarc-donut.component';
import { PayarcBarChartComponent } from './bar-chart/payarc-bar-chart.component';
import { PayarcGaugeComponent } from './gauge/payarc-gauge.component';
import { PayarcButtonDirective } from './button/payarc-button.directive';
import { PayarcTableComponent } from './table/payarc-table.component';
import { PayarcPagerComponent } from './pager/payarc-pager.component';

const PUBLIC = [
  PayarcPageHeaderComponent,
  PayarcFilterBarComponent,
  PayarcDetailCardComponent,
  PayarcStatTileComponent,
  PayarcStatusBadgeComponent,
  PayarcEmptyStateComponent,
  PayarcSectionCardComponent,
  PayarcDialogShellComponent,
  PayarcFormFieldComponent,
  PayarcCardComponent,
  PayarcSectionTitleComponent,
  PayarcSegmentedComponent,
  PayarcInlineAlertComponent,
  PayarcDonutComponent,
  PayarcBarChartComponent,
  PayarcGaugeComponent,
  PayarcButtonDirective,
  PayarcTableComponent,
  PayarcPagerComponent,
];

@NgModule({
  declarations: [...PUBLIC],
  imports: [CommonModule],
  exports: [...PUBLIC],
})
export class UiModule {}
